import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { jsx as t } from "react/jsx-runtime";
import o, { css as e } from "styled-components";
import { ColorTokens as r } from "@vds-tokens/color";
import { calculateRem as n } from "@vds-core/utilities";
var i = o.tr.withConfig({
    displayName: "StyledTableRow",
    componentId: "VDS__sc-gwkvr5-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
    var t = _ref.bottomLine;
    return !!t && e(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      border-bottom: ", " !important;\n    "])), function (t) {
      switch (t) {
        case "primary":
          return "".concat(n(1), " solid ").concat(r.elements.primary.onlight.value);
        case "secondary":
          return "".concat(n(1), " solid ").concat(r.elements.lowcontrast.onlight.value);
        default:
          return "none";
      }
    }(t));
  }),
  s = function s(o) {
    return t(i, Object.assign({}, o, {
      children: o.children
    }));
  };
export { s as default };